/**
 * Concatena clases de Tailwind, salteando lo falsy.
 *
 * Es el reemplazo de `clsx` + `tailwind-merge` + `class-variance-authority`, los
 * tres paquetes que usa `imprenta` para esto (SPEC 0003 §6). Con este uso
 * alcanza: nuestras clases se componen por condición, no por sobreescritura de
 * la misma propiedad.
 *
 * **Lo que NO hace, a diferencia de `tailwind-merge`:** resolver conflictos.
 * `cn("p-2", "p-4")` devuelve las dos y gana la que Tailwind haya emitido
 * después, que no es necesariamente la segunda. Si en algún componente hace
 * falta pisar una clase, se resuelve con un ternario y no agregando ambas.
 */
export function cn(...clases: (string | false | null | undefined)[]): string {
  return clases.filter(Boolean).join(" ");
}
